import * as api from './core-api'

export default api
